exports = module.exports = require("../../../../../../common/temp/node_modules/.pnpm/css-loader@3.2.1_webpack@5.68.0/node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "._2vM9UjxW4e7-uWgLaIE9pJ {\n    font-weight: 600;\n}\n", ""]);
// Exports
exports.locals = {
	"mention": "_2vM9UjxW4e7-uWgLaIE9pJ"
};